import type { AxiosInstance } from 'axios'
import axios from 'axios'
import { createContext, useContext } from 'react'

import type { IEnv } from './Env'

interface Params {
  getAccessToken: () => string | undefined
  env: IEnv
}

export function HTTPClient(params: Params) {
  const { getAccessToken, env } = params
  const httpClient = axios.create({ baseURL: env.API_URL })

  httpClient.interceptors.request.use((config) => {
    const token = getAccessToken()
    if (!token) {
      return config
    }

    return {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }
  })

  // // intercept 401 to redirect the user to the login page
  // httpClient.interceptors.response.use(
  //   (response) => response,
  //   (error) => {
  //     console.error(error)
  //     if (error.response.status === 401) {
  //       window.location.href = '/login'
  //     }
  //     return Promise.reject(error)
  //   },
  // )

  return httpClient
}

export const HttpClientContext = createContext<AxiosInstance | undefined>(
  undefined,
)

export function useHttpClient(): AxiosInstance {
  const httpClient = useContext(HttpClientContext)

  if (!httpClient) throw new Error('Please provide an HttpClient')

  return httpClient
}
